// extracted by mini-css-extract-plugin
export default {"portfolioList":"Portfolio_portfolioList__gT03r","portfolioContainer":"Portfolio_portfolioContainer__zXCYf"};